var map = {
	"./template.bet575": 1897,
	"./template.bet575.tsx": 1897,
	"./template.bet777": 1898,
	"./template.bet777.tsx": 1898,
	"./template.betgalaxy": 1899,
	"./template.betgalaxy.tsx": 1899,
	"./template.betprofessor": 1900,
	"./template.betprofessor.tsx": 1900,
	"./template.betroyale": 2147,
	"./template.betroyale.tsx": 2147,
	"./template.betstride": 1901,
	"./template.betstride.tsx": 1901,
	"./template.buffalobet": 1902,
	"./template.buffalobet.tsx": 1902,
	"./template.chromabet": 1903,
	"./template.chromabet.tsx": 1903,
	"./template.default": 55,
	"./template.default.tsx": 55,
	"./template.epicodds": 1904,
	"./template.epicodds.tsx": 1904,
	"./template.fiestabet": 1905,
	"./template.fiestabet.tsx": 1905,
	"./template.forsport": 1906,
	"./template.forsport.tsx": 1906,
	"./template.gigabet": 1907,
	"./template.gigabet.tsx": 1907,
	"./template.goldenbet888": 1908,
	"./template.goldenbet888.tsx": 1908,
	"./template.goldenrush": 1909,
	"./template.goldenrush.tsx": 1909,
	"./template.hyperbet": 1910,
	"./template.hyperbet.tsx": 1910,
	"./template.juicybet": 1911,
	"./template.juicybet.tsx": 1911,
	"./template.junglebet": 1912,
	"./template.junglebet.tsx": 1912,
	"./template.magnumbet": 1913,
	"./template.magnumbet.tsx": 1913,
	"./template.oldgill": 1914,
	"./template.oldgill.tsx": 1914,
	"./template.puntcity": 1915,
	"./template.puntcity.tsx": 1915,
	"./template.puntgenie": 2032,
	"./template.puntgenie.tsx": 2032,
	"./template.pyramidbet": 1916,
	"./template.pyramidbet.tsx": 1916,
	"./template.questbet": 2148,
	"./template.questbet.tsx": 2148,
	"./template.slambet": 1917,
	"./template.slambet.tsx": 1917,
	"./template.sterlingparker": 2149,
	"./template.sterlingparker.tsx": 2149,
	"./template.sugarcastle": 1918,
	"./template.sugarcastle.tsx": 1918,
	"./template.templebet": 1919,
	"./template.templebet.tsx": 1919,
	"./template.titanbet": 1920,
	"./template.titanbet.tsx": 1920,
	"./template.ts": 1000,
	"./template.vikingbet": 1921,
	"./template.vikingbet.tsx": 1921,
	"./template.volcanobet": 1922,
	"./template.volcanobet.tsx": 1922,
	"./template.wellbet": 1923,
	"./template.wellbet.tsx": 1923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2794;